import React from 'react';
import { Box, Typography, IconButton, useTheme } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Step } from '../../../state/map';

interface ModalHeaderProps {
  step: Step;
  stepNumber: number;
  totalSteps: number;
  onBack: () => void;
}

const stepTitles: Record<Step, string> = {
  [Step.Location]: 'Choose Location',
  [Step.Pins]: 'Add Pins',
  [Step.Style]: 'Select Style',
  [Step.Layout]: 'Choose Layout',
  [Step.Border]: 'Add Border',
  [Step.Size]: 'Select Size',
};

const ModalHeader: React.FC<ModalHeaderProps> = ({ 
  step, 
  stepNumber, 
  totalSteps, 
  onBack 
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '16px 20px',
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        position: 'sticky',
        top: 0,
        zIndex: 1
      }}
    >
      <IconButton
        onClick={onBack}
        sx={{
          marginRight: '12px',
          padding: '8px'
        }}
      >
        <ArrowBack />
      </IconButton>
      
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.primary,
            marginBottom: '2px'
          }}
        >
          {stepTitles[step]}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: '12px'
          }}
        >
          Step {stepNumber} of {totalSteps}
        </Typography>
      </Box>
    </Box>
  );
};

export default ModalHeader;
